import '@assets/styles/tiptap-editor.css';

import Modal from '@layouts/Modal';
import ErrorMessage from '@src/ui/elements/form/ErrorMessage';
import Textarea from '@src/ui/elements/form/Textarea';
import { firstError, hasError } from '@src/utils/errorMessageUtils';
import React from 'react';

export type IframeCodeErrorResponse = {
  value?: string[];
};

interface EditorIframeCodeModalProps {
  isOpen: boolean;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onClose: () => void;
  errors?: IframeCodeErrorResponse;
}

export const EditorIframeCodeModal: React.FC<EditorIframeCodeModalProps> = ({
  isOpen,
  value,
  onChange,
  onSubmit,
  onClose,
  errors,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal width='500px'>
      <div className='flex grow flex-col gap-8 px-8 py-10'>
        <div className='border-b border-b-gray-350 pb-4'>
          <h2 className='text-lg font-semibold'>iFrameコードを入力する</h2>
        </div>
        <button
          className='closeButton'
          onClick={onClose}
        >
          &times;
        </button>
        <div className='flex flex-col gap-[6px]'>
          <div className='flex gap-4'>
            <div className='flex w-full flex-col gap-2'>
              <Textarea
                value={value}
                placeholder='<iframe src="https://example.com" width="100" height="100"></iframe>'
                onChange={(e) => onChange(e.target.value)}
                height='200px'
                resizable='none'
                error={hasError(errors?.value)}
              />
              <ErrorMessage>{firstError(errors?.value)}</ErrorMessage>
            </div>
          </div>
        </div>
        <div className='modalFooter'>
          <button
            className='editorButton cancelButton'
            onClick={onClose}
          >
            キャンセル
          </button>
          <button
            className='editorButton insertButton'
            onClick={onSubmit}
          >
            動画を埋め込む
          </button>
        </div>
      </div>
    </Modal>
  );
};
